import { AccessibilityInfo } from 'react-native';

export const announceForAccessibility = (message: string): void => {
    if (message) {
        AccessibilityInfo.announceForAccessibility(message);
    }
};
